import { render } from "./YearsTab.vue?vue&type=template&id=b06ced2a&ts=true"
import script from "./YearsTab.vue?vue&type=script&lang=ts"
export * from "./YearsTab.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__